import { notification } from 'antd';
import { useChatContext } from '@/contexts/chat/context';
import { useRefs } from '@/scripts/hooks';
import { ChatMediaType } from '@/contexts/chat/scripts/hooks/useChatMediaCall/types';
import NotificationContent from './components/notificationContent';
import NotificationContentGroup from './components/notificationContent-group';

export default function CallNotification() {
  const { chatMediaCall } = useChatContext();

  const [api, contextHolder] = notification.useNotification({ top: 100 });

  const isGroup = useMemo(
    () => chatMediaCall.chatMediaInfo?.type === ChatMediaType.GROUP,
    [chatMediaCall.chatMediaInfo?.type]
  );

  const openCallNotification = useCallback(() => {
    api.open({
      message: null,
      description: isGroup ? <NotificationContentGroup /> : <NotificationContent />,
      placement: 'topRight',
      duration: null,
      closable: false,
      style: {
        width: '144px',
        background: 'rgb(0 0 0 / 70%)',
        backdropFilter: 'blur(60px)',
        borderRadius: '10px',
        padding: 0,
      },
    });
  }, [api, isGroup]);

  const closeCallNotification = useCallback(() => {
    api.destroy();
  }, [api]);

  const refs = useRefs({
    openCallNotification,
    closeCallNotification,
    chatMediaCall,
  });

  useLayoutEffect(() => {
    const { openCallNotification, closeCallNotification, chatMediaCall } = refs.current;
    if (chatMediaCall.openMediaNotice) {
      openCallNotification();
    } else {
      closeCallNotification();
    }
  }, [refs, chatMediaCall.openMediaNotice]);

  return <>{chatMediaCall.chatMediaInfo && contextHolder}</>;
}
